import './Footer.css'

const Footer = ({ onAboutClick }) => {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__content">
          <span className="footer__copyright">
            © 2026 Unity-BOT. All rights reserved.
          </span>
          <button className="footer__about-btn" onClick={onAboutClick}>
            About
          </button>
        </div>
        <p className="footer__disclaimer">
          Unity-BOT is not affiliated with CipSoft GmbH. This software is for educational purposes only.
        </p>
      </div>
    </footer>
  )
}

export default Footer
